<template>
  <div
    v-if="cover"
    class="-mb-20 border-white border-b-8 relative overflow-hidden dark:bg-gray-900 dark:text-gray-300"
  >
    <!-- Blur -->
    <img
      class="lg:block object-cover object-center absolute inset-0 w-full h-full filter blur-xl"
      :src="cover"
    />

    <!-- Image -->
    <div class="relative z-10">
      <div class="aspect-w-16 aspect-h-9 lg:aspect-none lg:h-64">
        <img
          class="lg:w-full lg:h-full object-contain object-center"
          :src="cover"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "pinia";
import { useBizStore } from "@/store/index.js";
export default {
  computed: {
    ...mapState(useBizStore, ["cover"]),
  },
};
</script>
